import { slotList } from "@/Util/manifest";
import { dataForms } from "@/Config/dataForms";

export default {
  versionMajor: 1,
  slots: {
    loginFactors: slotList([
      {
        id: "password",
        component: "LoginPassword",
        priority: 0,
      },
    ]),
  },
  homeRoute: ["dashboard", null],
  customRoutes: {
    dashboard: {
      listComponent: "Dashboard",
      itemComponent: "Dashboard",
    },
  },
  nav: slotList([
    {
      id: "dashboard",
      path: ["dashboard"],
      priority: 0,
      title: "Pregled",
      icon: "fa-solid fa-chart-line",
      color: "sky",
    },
    // {
    //   id: "users",
    //   path: ["User"],
    //   priority: 100,
    //   title: "Korisnici",
    //   icon: "fa-solid fa-users",
    //   color: "amber",
    // },
    // {
    //   id: "pages",
    //   path: ["Page"],
    //   priority: 100,
    //   title: "Stranice",
    //   icon: "fa-solid fa-file",
    //   color: "slate",
    //   items: slotList([
    //     {
    //       id: "pages",
    //       path: ["Page"],
    //       priority: 100,
    //       title: "Stranice",
    //       icon: "fa-solid fa-file",
    //     },
    //     {
    //       id: "menus",
    //       path: ["Menu"],
    //       priority: 200,
    //       title: "Meniji",
    //       icon: "fa-solid fa-bars",
    //     },
    //   ]),
    // },
    {
      id: "klijenti",
      path: ["Klijent"],
      priority: 100,
      title: "Klijenti",
      icon: "fa-solid fa-handshake-angle",
      color: "sky",
      items: slotList([
        {
          id: "klijenti",
          path: ["Klijent"],
          priority: 100,
          title: "Klijenti",
          icon: "fa-solid fa-handshake-angle",
        },
        {
          id: "lokacije",
          path: ["Lokacija"],
          priority: 200,
          title: "Lokacije",
          icon: "fa-solid fa-bars",
        },
        {
          id: "radnamesta",
          path: ["RadnoMesto"],
          priority: 200,
          title: "Radna mesta",
          icon: "fa-solid fa-pen-ruler",
        },
        {
          id: "proverasredine",
          path: ["ProveraSredine"],
          priority: 200,
          title: "Provere sredine",
          icon: "fa-solid fa-clipboard-list",
        },
        {
          id: "elektropregled",
          path: ["ElektroPregled"],
          priority: 200,
          title: "Pregledi elektro. inst.",
          icon: "fa-solid fa-bolt",
        },
        {
          id: "inspektorskipregled",
          path: ["InspektorskiPregled"],
          priority: 200,
          title: "Inspekcijski nadzor",
          icon: "fa-solid fa-helmet-safety",
        },
        {
          id: "zastitnaoprema",
          path: ["ZastitnaOprema"],
          priority: 200,
          title: "Zaštitna Oprema",
          icon: "fa-solid fa-helmet-safety",
        },
      ]),
    },
    {
      id: "oprema",
      path: ["Oprema"],
      priority: 100,
      title: "Oprema",
      icon: "fa-solid fa-tractor",
      color: "sky",
      items: slotList([
        {
          id: "oprema",
          path: ["Oprema"],
          priority: 100,
          title: "Oprema",
          icon: "fa-solid fa-tractor",
        },
        {
          id: "opremapregled",
          path: ["OpremaPregled"],
          priority: 200,
          title: "Pregledi",
          icon: "fa-solid fa-clipboard-list",
        },
      ]),
    },
    {
      id: "zaposleni",
      path: ["Zaposleni"],
      priority: 100,
      title: "Zaposleni",
      icon: "fa-solid fa-people-group",
      color: "sky",
      items: slotList([
        {
          id: "zaposleni",
          path: ["Zaposleni"],
          priority: 100,
          title: "Zaposleni",
          icon: "fa-solid fa-people-group",
        },
        {
          id: "angazovanja",
          path: ["Angazovanje"],
          priority: 200,
          title: "Angažovanja",
          icon: "fa-solid fa-circle-nodes",
        },
        {
          id: "lekarskipregledi",
          path: ["LekarskiPregled"],
          priority: 200,
          title: "Lekarski pregledi",
          icon: "fa-solid fa-user-doctor",
        },
        {
          id: "obuke",
          path: ["Obuka"],
          priority: 200,
          title: "Obuke",
          icon: "fa-solid fa-chalkboard",
        },
        {
          id: "povreda",
          path: ["Povreda"],
          priority: 200,
          title: "Povrede na radu",
          icon: "fa-solid fa-person-through-window",
        },
        {
          id: "reporthealthstart",
          path: ["ReportHealthStart"],
          priority: 100,
          title: "Uput prethodni pregl.",
          icon: "fa-solid fa-stethoscope",
        },
        {
          id: "reportsenviron",
          path: ["ReportHealthMid"],
          priority: 100,
          title: "Uput periodični pregl.",
          icon: "fa-solid fa-stethoscope",
        },
      ]),
    },
    // {
    //   id: "banner",
    //   path: ["BannerGroup"],
    //   priority: 100,
    //   title: "Baneri",
    //   icon: "fa-solid fa-bullhorn",
    //   color: "yellow",
    // },
    {
      id: "files",
      path: ["File"],
      priority: 900,
      title: "Predati dokumenti",
      icon: "fa-solid fa-hard-drive",
      color: "sky",
    },
    {
      id: "todo",
      path: ["ToDo"],
      priority: 900,
      title: "Planirane aktivnosti",
      icon: "fa-solid fa-clipboard-list",
      color: "sky",
    },
    {
      id: "extdoc",
      path: ["ExtDoc"],
      priority: 900,
      title: "Pravna regulativa",
      icon: "fa-solid fa-gavel",
      color: "sky",
      dynItems: "ExtDoc",
    },
    {
      id: "reports",
      path: ["ReportNextEvents"],
      priority: 900,
      title: "Izveštaji",
      icon: "fa-solid fa-chart-bar",
      color: "sky",
      items: slotList([
        {
          id: "reportsnext",
          path: ["ReportNextEvents"],
          priority: 100,
          title: "Naredni događaji",
          icon: "fa-solid fa-calendar-week",
        },
        {
          id: "reportpositions",
          path: ["ReportPositions"],
          priority: 100,
          title: "Radna mesta",
          icon: "fa-solid fa-person-digging",
        },
        {
          id: "reportsaccidents",
          path: ["ReportAccidents"],
          priority: 100,
          title: "Povrede na radu",
          icon: "fa-solid fa-person-through-window",
        },
        {
          id: "reportshealth",
          path: ["ReportHealth"],
          priority: 100,
          title: "Profesionalne bolesti",
          icon: "fa-solid fa-notes-medical",
        },
        {
          id: "reportshazards",
          path: ["ReportHazards"],
          priority: 100,
          title: "Izloženost bio. štet.",
          icon: "fa-solid fa-virus",
        },
        {
          id: "reportsdanger",
          path: ["ReportDanger"],
          priority: 100,
          title: "Izloženost karc.",
          icon: "fa-solid fa-disease",
        },
        {
          id: "reportssteps",
          path: ["ReportSteps"],
          priority: 100,
          title: "Mere za bezb.",
          icon: "fa-solid fa-person-shelter",
        },
        {
          id: "reportsequipment",
          path: ["ReportEquipment"],
          priority: 100,
          title: "Pregled opreme",
          icon: "fa-solid fa-clipboard-list",
        },
        {
          id: "reportselektro",
          path: ["ReportElektro"],
          priority: 100,
          title: "Pregled elektro.",
          icon: "fa-solid fa-bolt",
        },
        {
          id: "reportsenviron",
          path: ["ReportEnviron"],
          priority: 100,
          title: "Pregled radne sr.",
          icon: "fa-solid fa-warehouse",
        },
        {
          id: "reportsppe",
          path: ["ReportPPE"],
          priority: 100,
          title: "Evid. zaštitne opreme",
          icon: "fa-solid fa-helmet-safety",
        },

      ]),
    },
  ]),
  data: {
    ...dataForms,
  },
  labels: {
    localization: {
      language: "Jezik",
    }
  },
}
